/**
 * Klaviyo Forms Handler
 * Handles opening Klaviyo forms from buttons with data-klaviyo-form-id attributes.
 * Supports separate form IDs for mobile and desktop viewports.
 */
(function () {
  function initKlaviyoButtons() {
    document
      .querySelectorAll('[data-klaviyo-form-id-mobile], [data-klaviyo-form-id-desktop]')
      .forEach(function (button) {
        if (button.hasAttribute('data-klaviyo-initialized')) {
          return;
        }

        button.setAttribute('data-klaviyo-initialized', 'true');

        button.addEventListener('click', function (e) {
          e.preventDefault();

          // Determine if mobile or desktop based on viewport width
          const isMobile = window.innerWidth <= 767;
          const formIdMobile = this.getAttribute('data-klaviyo-form-id-mobile');
          const formIdDesktop = this.getAttribute('data-klaviyo-form-id-desktop');

          const formId = isMobile ? formIdMobile || formIdDesktop : formIdDesktop || formIdMobile;

          if (formId) {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', formId]);
          }
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKlaviyoButtons);
  } else {
    initKlaviyoButtons();
  }
})();
